import { FC } from "react";
import { DatePicker } from "rsuite";
import { CustomInputProps } from "../modal/FormModal";
import { DateTime } from "luxon";
import { isString } from "lodash";
import { timeStringToMillis } from "../../../util/date";

export function TimePickerInput(name: string): FC<CustomInputProps<any>> {
  return ({ values, updateValue, errorWrapper }) => {
    const value = values[name];
    return (
      <div className="flex flex-col gap-1">
        <DatePicker
          format="HH:mm"
          value={
            value
              ? isString(value)
                ? DateTime.fromMillis(timeStringToMillis(value)).toJSDate()
                : DateTime.fromMillis(value).toJSDate()
              : null
          }
          onChange={(value, _) => {
            updateValue(name, value ? value.getTime() : null);
          }}
        />
        {errorWrapper?.formError?.[name] && (
          <span className="text-red-600 font-poppins">
            {errorWrapper?.formError?.[name]}
          </span>
        )}
      </div>
    );
  };
}
